module.exports = __webpack_public_path__ + "img/weather43.25491902.png";